if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.productInfo = JSON.parse(
          this.querySelector('script[data-product-info]').textContent
        );

        this.quantityInput = this.querySelector('.quantity__input');

        this.reviews = this.querySelector('#PowerReviewsPDP');

        if (this.reviews) {
          this.initializeReviews();
        }
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onGroupChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.swatchChange,
          this.handleGroupSwatchChange.bind(this)
        );

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.onVariantUpdateUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const data = event.data;

            if (data.sectionId === this.sectionId && data.variant) {
              if (window.theme.dynamic_yield_enabled && DynamicYield) {
                DynamicYield.updateRecomendationContext(data.variant.sku);
              }
            }
          }
        );

        this.initQuantityHandlers();
        this.dispatchEvent(
          new CustomEvent('product-info:loaded', { bubbles: true })
        );
      }

      initializeReviews() {
        const variantsData = [];

        this.productInfo.variants.forEach((variant) => {
          variantsData.push({
            name: variant.name,
            description: this.productInfo.title,
            page_id_variant: variant.id,
            upc: variant.barcode,
          });
        });

        const productType = this.productInfo.type;

        if (window.pwr) {
          pwr('render', {
            api_key: window.theme.reviews.api_key,
            locale: window.theme.reviews.locale,
            merchant_group_id: window.theme.reviews.group_id,
            merchant_id: window.theme.reviews.merchant_id,
            page_id: this.productInfo.id,
            review_wrapper_url: `https://${location.host}/pages/write-a-review/?pr_page_id=${this.productInfo.id}`,
            on_back_to_top_click: function () {
              var target = document.querySelector('.pr-rid-tile-image');
              target.scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              });
            },
            on_render: function (config, data) {
              if (data.review_count !== undefined) {
                let value = document.querySelector(
                  '#msq-histogram-sizerating .pr-slider.pr-text-above'
                );
                let value2 = document.querySelector(
                  '#msq-histogram-sizing .pr-slider.pr-text-above'
                );
                let sizeSuggestion = document.getElementById('ProductFit');
                if (value && sizeSuggestion) {
                  if (productType === 'Footwear' || productType === 'Apparel') {
                    let actualValue = value.getAttribute('aria-label');
                    if (
                      actualValue === 'Small' ||
                      actualValue === 'Very small' ||
                      actualValue === 'too small' ||
                      actualValue.includes('small')
                    ) {
                      sizeSuggestion.innerHTML = `<span class="icon-sug">!</span><span>This item fits small</span>`;
                    } else if (
                      actualValue === 'Just right' ||
                      actualValue === 'true to size' ||
                      actualValue.includes('true to size')
                    ) {
                      sizeSuggestion.innerHTML = `<span class="icon-sug">!</span><span>This item fits true to size</span>`;
                    } else if (
                      actualValue === 'Big' ||
                      actualValue === 'Very big' ||
                      actualValue === 'too big' ||
                      actualValue.includes('big')
                    ) {
                      sizeSuggestion.innerHTML = `<span class="icon-sug">!</span><span>This item fits large</span>`;
                    }
                  }
                } else if (value2 && sizeSuggestion) {
                  if (productType === 'Footwear' || productType === 'Apparel') {
                    let actualValue = value2.getAttribute('aria-label');
                    if (
                      actualValue === 'Small' ||
                      actualValue === 'Very small' ||
                      actualValue === 'too small' ||
                      actualValue.includes('small')
                    ) {
                      sizeSuggestion.innerHTML = `<span class="icon-sug">!</span><span>This item fits small</span>`;
                    } else if (
                      actualValue === 'Just right' ||
                      actualValue === 'true to size' ||
                      actualValue.includes('true to size')
                    ) {
                      sizeSuggestion.innerHTML = `<span class="icon-sug">!</span><span>This item fits true to size</span>`;
                    } else if (
                      actualValue === 'Big' ||
                      actualValue === 'Very big' ||
                      actualValue === 'too big' ||
                      actualValue.includes('big')
                    ) {
                      sizeSuggestion.innerHTML = `<span class="icon-sug">!</span><span>This item fits large</span>`;
                    }
                  }
                }
              }
            },
            product: {
              name: this.productInfo.title,
              url: `https://${location.host}${location.pathname}`,
              image_url: this.productInfo.featured_image,
              description: this.productInfo.description,
              category_name: this.productInfo.type,
              upc: '',
              brand_name: this.productInfo.vendor,
              price: (this.productInfo.price / 100).toFixed(2),
              in_stock: this.productInfo.available,
              variants: variantsData,
            },
            subject: {
              '@context': 'https://schema.org',
              '@type': 'Product',
              name: this.productInfo.title,
              description: this.productInfo.description,
              url: `https://${location.host}${location.pathname}`,
              image: this.productInfo.featured_image,
              sku: this.productInfo.variants[0].sku,
              brand: {
                '@type': 'Brand',
                name: this.productInfo.vendor,
              },
              offers: {
                '@type': 'Offer',
                priceCurrency: 'CAD',
                url: `https://${location.host}${location.pathname}`,
                price: (this.productInfo.price / 100).toFixed(2),
                priceValidUntil: new Date(Date.now() + 31536000000)
                  .toISOString()
                  .split('T')[0],
                availability: this.productInfo.available
                  ? 'https://schema.org/InStock'
                  : 'https://schema.org/OutOfStock',
              },
              additionalProperty: [
                {
                  '@type': 'PropertyValue',
                  propertyID: 'item_group_id',
                  value: this.productInfo.id,
                },
              ],
            },
            components: {
              ReviewDisplay: 'PowerReviewDisplay',
              ReviewSnippet:
                window.innerWidth < 750
                  ? 'PowerReviewsPDPMobile'
                  : 'PowerReviewsPDP',
            },
          });
        }
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        this.onVariantUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html
            .querySelectorAll('.scroll-trigger')
            .forEach((element) =>
              element.classList.add('scroll-trigger--cancel')
            )
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleGroupSwatchChange(target) {
        if (!this.contains(target)) return;

        if (window.theme.dynamic_yield_enabled && DynamicYield) {
          DynamicYield.triggerSPA(
            this.dataset.productSku,
            this.dataset.productHandle
          );
          DynamicYield.updateRecomendationContext(this.dataset.productSku);
        }

        const swatch = target.closest('.swatch');

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          swatch.dataset.productUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;

        const shouldSwapProduct = false;
        const shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            [],
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: this.handleUpdateProductInfo(productUrl),
        });
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;

        if (window.theme.dynamic_yield_enabled && DynamicYield) {
          DynamicYield.changeAttribute(target.dataset.optionName, target.value);
        }

        this.resetProductFormState();

        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.url;
        this.pendingRequestUrl = productUrl;

        //const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldSwapProduct = false;
        const shouldFetchFullPage =
          this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : 'product-info';

          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML =
              html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              'text/html'
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.warn('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          'variant-selects [data-selected-variant]'
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          const updateSourceFromDestination = (
            id,
            shouldHide = (source) => false
          ) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(
              `#${id}-${this.dataset.section}`
            );
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));

              if (id === 'ProductTitle') {
                const mobileDestination = document.querySelector(
                  ".product__mobile [id*='ProductTitle']"
                );
                if (mobileDestination) {
                  mobileDestination.innerHTML = source.innerHTML;
                }
              }

              if (id === 'ProductPrice') {
                const mobileDestination = document.querySelector(
                  ".product__mobile [id*='ProductPrice']"
                );
                if (mobileDestination) {
                  mobileDestination.innerHTML = source.innerHTML;
                }
              }

              if (id === 'Sku') {
                const mobileDestination = document.querySelector(
                  ".product__mobile [id*='Sku']"
                );
                if (mobileDestination) {
                  mobileDestination.innerHTML = source.innerHTML;
                }
              }
            } else {
              const sources = html.querySelectorAll(
                `[id*="${id}-${this.sectionId}-"]`
              );

              sources.forEach((source) => {
                const destinations = this.querySelector(`#${source.id}`);

                if (source && destinations) {
                  destinations.innerHTML = source.innerHTML;
                  destinations.classList.toggle('hidden', shouldHide(source));
                }
              });
            }
          };

          updateSourceFromDestination('ProductMediaWrapper');
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);

          updateSourceFromDestination('ProductLimitedEditionLabel');
          updateSourceFromDestination('ProductCoreColoursLabel');

          updateSourceFromDestination('ProductTitle');
          updateSourceFromDestination('ProductPrice');
          updateSourceFromDestination('Sku', ({ classList }) =>
            classList.contains('hidden')
          );
          updateSourceFromDestination(
            'Inventory',
            ({ innerText }) => innerText === ''
          );

          updateSourceFromDestination('ProductText', ({ classList }) =>
            classList.contains('hidden')
          );

          updateSourceFromDestination('ProductBuyButtons');

          updateSourceFromDestination('ProductSticky');

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState(
          {},
          '',
          `${url}${variantId ? `?variant=${variantId}` : ''}`
        );
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity
            ? parseInt(this.quantityInput.dataset.cartQuantity)
            : 0,
          min: this.quantityInput.dataset.min
            ? parseInt(this.quantityInput.dataset.min)
            : 1,
          max: this.quantityInput.dataset.max
            ? parseInt(this.quantityInput.dataset.max)
            : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(
          `product-recommendations[data-section-id^="${relatedProductsSectionId}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}





